import type { ComponentPropsWithoutRef } from 'react';
import { cn } from 'src/utils/cn';

export const HeaderSecondaryBackground = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div {...props} className={cn('border-b bg-white', className)} />;
};

export const HeaderSecondaryCenter = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div {...props} className={cn('min-h-[4.3rem]', className)} />;
};
